'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IfRoleDirectiveController=class IfRoleDirectiveController{
static get $inject(){
return['$scope','userService'];
}

constructor($scope,userService){
this._userService=userService;
const enabledRoles=this.role.split(',').map(r=>r.trim());

$scope.$watch('controller.currentUser',(newUser,oldUser)=>{
if(!_.exists(newUser)){
this.isEnabled=!1;
return;
}

if(_.exists(this.isEnabled)&&(newUser===oldUser||newUser.role===_.get(oldUser,'role'))){
return;
}

this.isEnabled=enabledRoles.includes(newUser.role);
});
}

get currentUser(){
return this._userService.currentUser;
}};let


IfRoleDirective=class IfRoleDirective extends BaseControllerBackedDirective{
get textBindings(){
return['role'];
}

get template(){
return'<ng-transclude ng-if="controller.isEnabled"/>';
}

get controller(){
return IfRoleDirectiveController;
}

factory(){
let directive=super.factory();
directive.transclude=!0;
return directive;
}};


module.exports=IfRoleDirective;
//# sourceMappingURL=ifRoleDirective.js.map
